let defaultConfig;

let config = {
  hostURL: window.location.protocol + '//' + window.location.host + '/piction/',
  cardURL: window.location.protocol + '//' + window.location.host,
  initialQuery: {
    type: 'Search',
    searchKeyword: 'AGE',
    value: '2',
    label: 'Recent Uploads',
    labelLocale: { en: 'Recent Uploads', fr: 'Téléchargements récents' },
    description: 'All images uploaded in the last couple of days',
    descriptionLocale: {
      en: 'All images uploaded in the last couple of days',
      fr: 'Toutes les images téléchargées au cours des derniers jours',
    },
  },
  baseSearchWord: false, // use instead of "WORDS":xxxx for simple search
  externalLogin: false, // '/signon/login'
  useUserDefinedConfig: true,
  disableRightClick: false,
  useZoomify: true,
  useWebQualityForSmallThumb: true,
  umoExternalLink: false, // { title: 'Reuse Image', url: 'http://localhost:8080/external-tools/image-reuse/index.html' },
  umoTitleMetatag: false, // 'APELLES.PRIMARY_TITLE',
  umoDisplayTitleAboveImage: false,
  showTitleOverGalleryUmo: true,
  discovererEditMode: false,
  setSchemaName: false, // [{ schemaName: 'WEB_CE', displayTitle: 'Object Information' }],
  restrictEditing: false,
  enableCopyUMOs: false,
  collapseCategories: false,
  categoriesSortByCC: false,
  inProgressNotifications: false,
  secureWorkspaceShareRoles: false, // SECURE/FALSE
  categoryCounts: false,
  enableUmoCompare: false,
  enableLinkShare: false,
  removeEmptyMetatags: false,
  usePopupForDownloads: false,
  tombstoneCharacterLimit: 50,
  alternateReps: false,
  autoExpandMetaSchema: false,
  useHighlights: false,
  removeHomeButton: false,
  removeWorkspaces: false,
  removeCategories: false,
  removeWorkspaceCardView: false,
  addExternalButton: false,
  tabTitle: false,
  removeLogoutBtn: false,
  navExternalLink: false, //[{ title: 'More Info', url: 'https://www.example.com', ext: false }],
  logoLink: false,
  reportImage: true,
  listViewMetatags: false,
  listViewRemoveMediaData: false,
  displayNavBarLabels: false,
  alternateExcRelational: false,
  showLanguageSelection: false,
  enableSortCategory: false,
  portalShareUsername: false,
  downloadPurposeFields: false,
  sortItemMetatag: false,
  userOldLoader: false,
  umoGallery: {
    gridViewDefault: true,
    umosPerPage: 25,
    sortByOptions: [
      {
        value: 'D',
        label: 'Date loaded',
        labelLocale: { en: 'Date loaded', fr: 'FR Date loaded' },
        isAscending: true,
      },
      {
        value: 'D',
        label: 'Date loaded',
        labelLocale: { en: 'Date loaded', fr: 'FR Date loaded' },
        isDescending: true,
      },
    ],
    filterByOptions: [
      { type: 'dateRange' },
      { type: 'metatag', category: 'PICTION EXAMPLE', name: 'LIST OF VALUES' },
      { type: 'metatag', category: 'PICTION EXAMPLE', name: 'OPTIONAL CHECKBOX' },
      { type: 'metatag', category: 'PICTION EXAMPLE', name: 'BOOLEAN' },
    ],
  },
  umoRatings: {
    display: true, // If true, display ratings stars.
    complex: false, // Set to true for global ratings functionality.
    overrideMetatag: false, // 'PICTION EXAMPLE.RATINGS', // Provide overriding metatag to store/retrieve rating data from.
    // If using global ratings, do not set metatag override (uses INTERNAL.RATINGS by default).
  },
  customClassMetatag: '',
  thesaurus: {
    show: false,
    mainLabel: 'Projects',
    id: 6548525,
  },
  excelExportMetatags: [6344540, 6344542], // standard.accession number and description
  videoOriginalIndexForWeb: '2',
  audioOriginalIndexForWeb: '2',
  templates: {
    basket: {
      name: 'KAUI2.BASKET',
      label: 'Usage Clearance',
      labelLocale: { en: 'Usage Clearance', fr: 'FR Usage Clearance' },
    },
    photoBasket: {
      name: 'KAUI2.PHOTOBASKET',
      label: 'Photography Request',
      labelLocale: { en: 'Photography Request', fr: 'FR Photography Request' },
    },
    authoriseWorkflow: {
      name: 'KAUI2.Authorisation',
      label: 'Authorise Request',
      labelLocale: { en: 'Authorise Request', fr: 'FR Authorise Request' },
    },
    workflowDashboard: {
      name: 'JOB.Login_Page_Workbench',
      label: 'Workflow Dashboard',
      labelLocale: { en: 'Workflow Dashboard', fr: 'FR Workflow Dashboard' },
    },
    upload: {
      name: 'KAUI2.BROWSER_LOADER',
      label: 'Upload',
      labelLocale: { en: 'Upload', fr: 'FR Upload' },
    },
  },
  // Customise various menus and their ordering
  menuOptions: {
    adminMenu: ['auth', 'metaAttach', 'workflowDash', 'usersAndRoles', 'manageCategoryRoles', 'publish', 'newRelational'],
    umoMenu: ['editMetadata', 'crop', 'resize', 'videoAnno', 'videoSnip', 'relateUMOs', 'imageAnno'],
    workspaceMenu: ['exportXLS', 'exportAllToXLS', 'exportPPT', 'exportZIP', 'exportPDF', 'saveToDropbox', 'usageBasket', 'photoBasket', 'email', 'relateUMOs', 'resizeAll', 'shareAsPortal', 'shareExternalPortal'],
    categorySpannerMenu: ['subCategory', 'edit', 'move', 'upload'], // , 'sort'],
    customWorkspaceMenu: false,
    formsMenu: {
      enabled: false,
      options: {
        mediaRequest: {
          name: 'JOB.Basket Media Asset Request',
          label: 'External Media Request Form',
          labelLocale: { en: 'External Media Request Form', fr: 'FR External Media Request Form' },
        },
        eventRequest: {
          name: 'JOB.Basket Photo Event Request',
          label: 'Events Request Form',
          labelLocale: { en: 'Events Request Form', fr: 'FR Events Request Form' },
        },
      },
    },
  },
  advanced: {
    zoomifyMetatag: false, //{ tagName: 'SYSTEM.IMAGE Authoriser', tagValue: ['POCWORKBENCH'] },
  },
  displayDisclaimer: false, // 'ALWAYS','NEVER','ONCE'
  disclaimerMessage: 'Upon Using this Service, you agree to our terms and services',
};

/**
 * @param {{appConfig:string}} config file
 */
try {
  if (appConfig) {
    Object.assign(config, appConfig); // Global variable from custom app config.
  }
} catch (e) {
} finally {
  // this will store the default remote config merged with the local config
  // it will be used to revert back to if appConfig gets overwritten with the user defined config
  defaultConfig = JSON.parse(JSON.stringify(config));
}

export function updateConfig(data = {}) {
  Object.assign(config, data);
}

export function resetConfig() {
  // config gets reset in this manner -- manually deletion of keys and then merged/assigned --
  // with the default so we keep the same object. if we assign a new object, the config being
  // imported into the other files won't be updated.
  Object.keys(config).forEach((key) => {
    delete config[key];
  });
  Object.assign(config, JSON.parse(JSON.stringify(defaultConfig)));
}

export default config;



// WEBPACK FOOTER //
// ./src/js/appConfig.js